import * as React from "react";

import { CheckoutContext } from "@swiggy-private/checkout-core";
import { TransactionContext } from "@payment-client/contexts/TransactionContext";
import useProcessTransaction from "@payment-client/hooks/useProcessTransaction";
import useCreateTransaction from "@payment-client/hooks/UseCreateTransaction";

export function TransactionContextProvider(props: { children: React.ReactNode }): React.ReactElement {
    const checkoutContextValue = React.useContext(CheckoutContext);
    const [processingTransaction] = useProcessTransaction(checkoutContextValue);
    const [{ createTransactionInProgress, transactionData }, setCreateTransaction] = useCreateTransaction();

    const transactionContextValue = React.useMemo(
        () => ({
            createTransactionInProgress,
            processingTransaction,
            transactionData,
            doCreateTxn: setCreateTransaction,
        }),
        [createTransactionInProgress, processingTransaction, setCreateTransaction, transactionData],
    );

    return <TransactionContext.Provider value={transactionContextValue}>{props.children}</TransactionContext.Provider>;
}
